import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `โฮมแชทนิรนามของ ${ctx.brand}`,
    languageButtonLabel: `ภาษา`,
    languageModalTitle: `เลือกภาษา`,
    languageModalCloseLabel: `ปิดเมนูภาษา`,
  },
  languageOptions: {
    'en-US': {
      label: `อังกฤษ (สหรัฐอเมริกา)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `อังกฤษ (เคนยา)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `อังกฤษ (ไนจีเรีย)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `อังกฤษ (สิงคโปร์)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `โปรตุเกส (โปรตุเกส)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `โปรตุเกส (บราซิล)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `เยอรมัน (เยอรมนี)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `เยอรมัน (ออสเตรีย)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `เยอรมัน (สวิตเซอร์แลนด์)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `สเปน (สเปน)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `ฝรั่งเศส (ฝรั่งเศส)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `อิตาลี (อิตาลี)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `ดัตช์ (เนเธอร์แลนด์)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `โปแลนด์ (โปแลนด์)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `สวีเดน (สวีเดน)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `เดนมาร์ก (เดนมาร์ก)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `ฟินแลนด์ (ฟินแลนด์)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `นอร์เวย์ (นอร์เวย์)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `ไอซ์แลนด์ (ไอซ์แลนด์)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `ญี่ปุ่น (ญี่ปุ่น)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `เกาหลี (เกาหลีใต้)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `จีน (จีน)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `กวางตุ้ง (เขตปกครองพิเศษฮ่องกงแห่งสาธารณรัฐประชาชนจีน)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `เวียดนาม (เวียดนาม)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `ไทย (ไทย)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `อินโดนีเซีย (อินโดนีเซีย)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `สวาฮีลี (เคนยา)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `ฮินดี (อินเดีย)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `บังกลา (บังกลาเทศ)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `มราฐี (อินเดีย)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `เตลูกู (อินเดีย)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `เปอร์เซีย (อิหร่าน)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `อูรดู (ปากีสถาน)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `ปัญจาบ (ปากีสถาน)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `ไนจีเรียนพิดจิน (ไนจีเรีย)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `รัสเซีย (รัสเซีย)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `อาหรับ (ซาอุดีอาระเบีย)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `อาหรับ (สหรัฐอาหรับเอมิเรตส์)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `อาหรับ (กาตาร์)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `อาหรับโมร็อกโก (โมร็อกโก)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `ตุรกี (ตุรกี)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `เลือกภาษา`,
    closeLabel: `ปิดเมนูภาษา`,
  },
  languageHint: (ctx) => `ข้ามไปยัง ${ctx.localesCount}+ ภาษาได้โดยไม่ต้องสร้างบัญชี.`,
  readPagePrompt: ({languageLabel}) => `อ่านหน้านี้เป็น${languageLabel}.`,
};
